import { render } from "./HelloWorld.vue?vue&type=template&id=1ab57524&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=1ab57524&scoped=true&lang=scss"

import exportComponent from "/home/stork/stork/pwa_test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ab57524"]])

export default __exports__